<div
  *ngIf="loading; else dashboardContent"
  class="w-full flex justify-center items-center h-96"
>
  <div class="flex flex-col items-center gap-3">
    <i class="pi pi-spin pi-spinner text-3xl text-blue-500"></i>
    <span class="text-gray-500 text-sm">Chargement des statistiques...</span>
  </div>
</div>

<ng-template #dashboardContent>
  <!-- TON DASHBOARD -->
  <div class="w-full p-6 bg-gray-100 flex flex-col gap-6">
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

    <div class="rounded-lg bg-white shadow-sm p-6 flex flex-col gap-6">
      <div>
        <div
          class="mb-6 p-5 rounded-xl border-l-4 border-blue-600 bg-blue-50 dark:bg-gray-800 shadow-md"
        >
          <div class="flex items-center mb-3">
            <h2
              class="text-lg font-bold text-blue-800 dark:text-blue-300 leading-none"
            >
              Information
            </h2>
          </div>

          <p
            class="text-base text-gray-700 dark:text-gray-300 whitespace-pre-line leading-relaxed"
          >
            {{ selectedDescription }}
          </p>
        </div>
      </div>

      <div
        class="self-stretch h-full flex-col justify-start items-start gap-5 flex"
      >
        <div
          class="self-stretch flex-col justify-start items-center gap-6 flex"
        >
          <div
            class="self-stretch flex-col justify-start items-start gap-6 flex"
          >
            <div
              class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex"
            >
              <div class="w-full flex justify-center items-center">
                <h1
                  class="text-3xl font-semibold text-gray-900 mt-5 text-center"
                >
                  Statistiques des candidatures – Cohorte
                  <span
                    class="ml-2 px-3 py-1 text-sm font-medium bg-blue-100 text-blue-700 rounded-full"
                  >
                    {{ selectedCode }}
                  </span>
                </h1>
              </div>
            </div>
            <div
              class="w-full p-1 justify-center items-end tarte-tab-ctnr gap-2.5 inline-flex"
            >
              <div class="flex tab-ctnr max-w-full overflow-x-auto">
                <div class="ctnr-tableau-recap">
                  <table class="tableau-recap text-gray-900 bg-blue-100">
                    <thead class="align-center">
                      <tr>
                        <th class="px-8 py-2 inter-semibold"></th>
                        <th class="px-8 py-2 inter-semibold light-blue-bg">
                          Hommes
                        </th>
                        <th class="px-8 py-2 inter-semibold light-blue-bg">
                          Femmes
                        </th>
                        <th
                          class="px-8 py-2 inter-semibold light-blue-bg text-left"
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th
                          class="px-8 py-2 inter-semibold light-blue-bg text-left"
                        >
                          Candidats
                        </th>
                        <td class="px-8 py-2 inter-medium light-blue-bg">
                          {{ homme }}
                        </td>
                        <td class="px-8 py-2 inter-medium light-blue-bg">
                          {{ femme }}
                        </td>
                        <td class="px-8 py-2 inter-medium light-blue-bg">
                          {{ homme + femme }}
                        </td>
                      </tr>

                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dashboard -->
      <div class="flex flex-col gap-6">
        <!-- Ligne 1 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          <div class="bg-white p-4 rounded shadow">
            <app-coursera-diplome-chart
              [data]="dashboardData.diplome || []"
            ></app-coursera-diplome-chart>
          </div>
          <div class="bg-white p-4 rounded shadow">
            <app-coursera-statut-chart
              [data]="dashboardData!.statut || []"
            ></app-coursera-statut-chart>
          </div>
          <div class="bg-white p-4 rounded shadow">
            <app-coursera-migration-chart
              [data]="dashboardData.migration || []"
            ></app-coursera-migration-chart>
          </div>
        </div>

        <!-- Ligne 2 -->
        <div class="bg-white p-4 rounded shadow">
          <app-coursera-pays-chart
            [data]="dashboardData.pays || []"
          ></app-coursera-pays-chart>
        </div>

        <!-- Ligne 3 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div
            class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100"
          >
            <app-coursera-genre-chart
              [data]="dashboardData.genre || []"
            ></app-coursera-genre-chart>
          </div>

          <div
            class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100"
          >
            <app-coursera-handicap-chart
              [data]="dashboardData.handicap || []"
            ></app-coursera-handicap-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
